import { config } from "./config";
import { SPECIAL_CHARS_PATTERN } from "./constants";

export const highlightApi = (ref, searchTerm, highlightKey, occurence, excludeClasses, priority) => {
    try{
        // If the CSS Custom Highlight API is not supported
        if (!CSS.highlights) {
            //searchContainer.textContent = "CSS Custom Highlight API not supported.";
            return;
        }
        
        // Clear the HighlightRegistry to remove the previous search results.
        //CSS.highlights.clear();
        
        //Element to find and highlight the text in
        var searchContainer = ref.current;
        var searchContainerText = searchContainer.textContent.toLowerCase();
        
        var escapedSearchTerm = searchTerm.replace(SPECIAL_CHARS_PATTERN, "\\$&");
        var searchTermLength = searchTerm.length;

        const reg = new RegExp(`(${escapedSearchTerm})`,"gi");
        var matched = searchContainerText.matchAll(reg);
        var matches = [...matched];
        var matchesIndex = 0;

        var targetMatchData = matches[matchesIndex];
        var targetMatchStartIndex = targetMatchData.index;
        var targetMatchEndIndex = targetMatchStartIndex + searchTermLength;

        const treeWalker = document.createTreeWalker(searchContainer, NodeFilter.SHOW_TEXT);

        var tempIndex = 0;
        let currentNode = treeWalker.nextNode();
        
        var rangeStart = null;
        var rangeIndices = [];
    
        while (currentNode) {
            //"1.3.2 Leukopenia (<4000 WBC/mm3) or leukocytosis (>12,000 WBC/mm3)"
            var currentNodeMaxIndex = tempIndex + currentNode.length;

            //If current node includes start index of match and rangeStart is not yet set
            if(targetMatchStartIndex <= currentNodeMaxIndex && rangeStart==null) {
                //Start index of the match inside currentNode text
                var nodeMatchStartIndex = targetMatchStartIndex - tempIndex;
                rangeStart=[currentNode,nodeMatchStartIndex];
            }

            //If current node includes end index of match
            if(targetMatchEndIndex <= currentNodeMaxIndex){
                //End index of the match inside currentNode text
                var nodeMatchEndIndex = targetMatchEndIndex - tempIndex;

                //If visible and does not have parentElement with an excluded class
                if(!(excludeClasses!=null && excludeClasses.some(x => (currentNode.parentElement.className).includes(x))) && currentNode.parentElement.checkVisibility()==true){
                    rangeIndices.push({
                        start: rangeStart,
                        end: [currentNode,nodeMatchEndIndex]
                    })
                }
                rangeStart=null;

                //If there are remaining matches
                if(matches.length > matchesIndex + 1){ 
                    //Update variables with next match info
                    matchesIndex = matchesIndex + 1;
                    targetMatchData = matches[matchesIndex];
                    targetMatchStartIndex = targetMatchData.index;
                    targetMatchEndIndex = targetMatchStartIndex + searchTermLength;

                    //If next match index is within currentNode
                    if(targetMatchStartIndex < currentNodeMaxIndex){
                        //Bypass incrementing tempIndex and currentNode
                        continue;
                    }
                }
                //Exit loop
                else{
                    break;
                }
            }
            tempIndex = currentNodeMaxIndex;
            currentNode = treeWalker.nextNode();
        }

        //If only retrieving certain occurence of match
        if(occurence!=null && rangeIndices[occurence-1]){
            rangeIndices = [rangeIndices[occurence-1]];
        }

        //Convert rangeIndices into array of ranges
        var ranges = rangeIndices.map((indices, i) => {
            try {
                const range = new Range();
                range.setStart(indices.start[0], indices.start[1]);
                range.setEnd(indices.end[0], indices.end[1]);
                return range;
            } 
            catch(rangeError){
                config.isDebugEnabled && console.log(rangeError);
            }
        });

        // Create a Highlight object for the ranges.
        const searchResultsHighlight = new window.Highlight(...ranges.flat());
        
        //Set priority of highlight (larger numbers have higher priority)
        if(priority!=null){
            searchResultsHighlight.priority=priority;
        }
        
        // Register the Highlight object in the registry.
        CSS.highlights.set(highlightKey!=null ? highlightKey : "search-results", searchResultsHighlight);
    }
    catch(err){
        config.isDebugEnabled && console.log(err);
    }
}